import { Tag } from '@iheartjane/reefer';

interface SpecialTagProps {
  label: string;
}

export const SpecialTag = ({ label }: SpecialTagProps) => {
  return <Tag label={label} color="text-info" background="info" />;
};
